module.exports = __webpack_public_path__ + "static/assets/3ab1c1143de93e108ebc3690f90613ef.svg";